$(function () {

    var listGroupCollapse = [],
        listGroupCollapseItem = [],
        btnCollapse = [];
    $(".list-group-collapse").each(function (index) {
        listGroupCollapse[index] = $(this);
        listGroupCollapseItem[index] = listGroupCollapse[index].find('.list-group-collapse-item');
        btnCollapse[index] = listGroupCollapse[index].find('.list-group-collapse-btn');
        if(listGroupCollapse[index].height() < 242) {
            listGroupCollapseItem[index].remove();
        }
        btnCollapse[index].click(function() {
            listGroupCollapse[index].css({
                'max-height': 'initial'
            });
            listGroupCollapseItem[index].remove();
        })
    });
});